module.exports = __webpack_public_path__ + "static/img/shop.6db20eec.svg";